import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/theme-blue.css";
import React from "react";
import PropTypes from "prop-types";

import { AgGridReact } from "ag-grid-react";
import { LicenseManager } from "ag-grid-enterprise/main";
import NumericEditor from "./numericEditor";

LicenseManager.setLicenseKey(
  "Ecological_Information_Management_System_EIMS_2Devs28_July_2018__MTUzMjczMjQwMDAwMA==c1bd39e0db1ded4f3603fbd07733ca4e"
);

const createEmptyObjectsArray = num => Array.from(Array(num)).map(() => ({}));
const initialNumberOfRows = 1000;

const AgGridWrapper = props => {
  const { columnDefs, setGridAPI, gridApi } = props;
  const resizeCols = () => gridApi && gridApi.sizeColumnsToFit();
  return (
    <div
      className="ag-blue"
      style={{
        width: "100%",
        height: window.innerHeight - 100,
        minHeight: "500px"
      }}
    >
      <AgGridReact
        gridOptions={{
          getRowStyle: ({ data }) => {
            if (data.response === "fulfilled") {
              return { background: "rgb(167, 255, 184)" };
            }
            return false;
          }
        }}
        frameworkComponents={{
          numericEditor: NumericEditor
        }}
        enterMovesDown
        toolPanelSuppressRowGroups
        toolPanelSuppressValues
        toolPanelSuppressSideButtons
        toolPanelSuppressPivots
        toolPanelSuppressPivotMode
        enableRangeSelection
        enableCellChangeFlash
        suppressColumnMoveAnimation
        enableColResize
        columnDefs={columnDefs}
        rowData={createEmptyObjectsArray(initialNumberOfRows)}
        onDisplayedColumnsChanged={resizeCols}
        onGridSizeChanged={resizeCols}
        onGridReady={gridRef => setGridAPI(gridRef.api)}
      />
    </div>
  );
};
AgGridWrapper.propTypes = {
  // eslint-disable-next-line
  columnDefs: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line
  samples: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line
  gridOptions: PropTypes.object,
  setGridAPI: PropTypes.func.isRequired,
  // eslint-disable-next-line
  gridApi: PropTypes.object
};

AgGridWrapper.defaultProps = {
  columnDefs: [],
  samples: [],
  gridOptions: undefined,
  gridApi: undefined
};
export default AgGridWrapper;
